<script setup lang="ts">
import { useSlots } from 'vue';

const props = withDefaults(
  defineProps<{
    message?: string;
    title?: string;
    type?: 'info' | 'warning' | 'danger' | 'success';
    size?: 'default' | 'compact';
  }>(),
  {
    size: 'default',
  },
);

const slots = useSlots();
</script>

<template>
  <div
    class="rounded-md border"
    :class="[
      props.size === 'compact' ? 'p-2 text-xs leading-relaxed' : 'p-4 text-sm',
      (!props.type || props.type === 'info') &&
        'border-sky-300 bg-sky-100 text-sky-900',
      props.type === 'warning' &&
        'border-amber-300 bg-amber-100 text-amber-900',
      props.type === 'danger' && 'border-rose-300 bg-rose-100 text-rose-900',
      props.type === 'success' &&
        'border-emerald-300 bg-emerald-100 text-emerald-900',
    ]"
  >
    <div
      v-if="props.title"
      class="font-semibold"
      :class="props.size === 'compact' ? 'mb-0.5' : 'mb-1'"
    >
      {{ props.title }}
    </div>
    <div v-if="slots.default">
      <slot />
    </div>
    <div v-else-if="props.message">{{ props.message }}</div>
  </div>
</template>
